module.exports = __webpack_public_path__ + "img/CMMCCourse.0baf4f20.png";